// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"407":"e93f1acd","436":"aca682d0","453":"f394a27d","501":"87022891","606":"0bda5e0d","821":"24bb6223","925":"947297b5","969":"be85cc9a"}[chunkId] + ".chunk.js";
};